import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { log } from './shared/utils/console.js'

// Talisis:
const firebaseConfig = {
    apiKey: "AIzaSyC8XqZJ2gGfgTE8F9L4l6vu1fPwBu6oDDc",
    authDomain: "point-app-movil.firebaseapp.com",
    projectId: "point-app-movil",
    storageBucket: "point-app-movil.appspot.com",
    messagingSenderId: "364449213750",
    appId: "1:364449213750:web:6d0ba24c56371506ead797",
    measurementId: "G-Q4TTJR6RMN"
};

export const initializeFirebase = () => {
    return initializeApp(firebaseConfig);
};

export const requestForToken = async () => {
    try {
        // Verificar el estado de los permisos antes de intentar obtener el token
        const permission = Notification.permission;
        
        // Si los permisos están bloqueados o denegados, no intentar obtener el token
        if (permission === 'denied') {
            return null;
        }

        const messaging = getMessaging();
        let PUBLIC_VAPID_KEY = 'BE098FLv48uWy7tkmctrUxw3bFE4lMoe7zt6v1Ngtqulu60DD_wag1mV9H_CYbslNHKEWRZpvLy6C4JpcvPVqus'; // Talisis
        
        const token = await getToken(messaging, { vapidKey: PUBLIC_VAPID_KEY });
        
        if (token) {
            return token;
        } else {
            return null;
        }
    } catch (error) {
        // Silenciar errores de permisos bloqueados
        if (error.code !== 'messaging/permission-blocked' && error.code !== 'messaging/permission-default') {
            log('An error occurred while retrieving token. ', error);
        }
        return null;
    }
};

export const onMessageListener = () =>
    new Promise(resolve => {
        const messaging = getMessaging();
        onMessage(messaging, (payload) => {
            resolve(payload);
        });
    });